<template>
  <div class="dynamicNews">
    <div class="dynamicNewsCon">
      <p>进行中商机：<span>{{newsInfo.goingBussinessNumber}}个</span></p>
      <p>商机被查看次数：<span>{{newsInfo.viewNumber}}次</span></p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['newsInfo'],
  data () {
    return {
      viewNumber:0
    }
  },
  components: {
  },
  created () {
  },
  methods: {
    getCount(){
		    this.$axios.post('/onelink.mdata.main.api/number/findBussinessViewNumber', {
        }).then((res) => {
          this.viewNumber = res.data;
         this.$emit("tranDate", this.viewNumber);
        }).catch((err) => {
            console.log(err)
        })
    },
    getViewNumbers : function() {
			/* 每隔三分钟刷新商机查看次数
			第一个参数为要调用的函数（记得不要带括号）
      第二个参数是定时的时间间隔（这里为两秒钟 */
			setInterval(this.getCount,1000 * 180);
		}
  },
  mounted () {
    this.$nextTick(function() {
			this.getViewNumbers();
		})

  },

}
</script>



// WEBPACK FOOTER //
// src/components/dynamicNews/index.vue